import api from './api';
import {
  WorkflowDto,
  TaskLabelDto,
  TaskColumnDto,
  TaskDto,
  TaskCreateDto,
  TaskUpdateDto,
} from '../types/django';

// =========================
// WORKFLOW
// =========================
export const workflowService = {
  async getAll(workflowType?: string): Promise<WorkflowDto[]> {
    const params = workflowType ? { search: workflowType } : {};
    const response = await api.get('/workflows/', { params });
    return response.data.results ?? response.data;
  },

  async getById(id: number): Promise<WorkflowDto> {
    const response = await api.get(`/workflows/${id}/`);
    return response.data;
  },
 
async create(data: {
  name: string;
  description?: string;
  workflow_type: string;
  color?: string;
  is_active?: boolean;
}): Promise<WorkflowDto> {
  const response = await api.post('/workflows/', data);
  return response.data;
},

  async update(id: number, data: Partial<WorkflowDto>): Promise<WorkflowDto> {
    const response = await api.patch(`/workflows/${id}/`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/workflows/${id}/`);
  },
};

// =========================
// LABEL
// =========================
export const taskLabelService = {
  async getAll(): Promise<TaskLabelDto[]> {
    const response = await api.get('/labels/');
    return response.data.results ?? response.data;
  },
};
// =========================
// COLUMN 
// =========================

export const taskColumnService = {
  async getAll(workflowId?: number): Promise<TaskColumnDto[]> {
    const params = {
      ...(workflowId ? { workflow: workflowId } : {}),
      ordering: 'position',
    };

    const response = await api.get('/columns/', { params });
    return response.data.results ?? response.data;
  },

  async getById(id: number): Promise<TaskColumnDto> {
    const response = await api.get(`/columns/${id}/`);
    return response.data;
  },

  // Créer une colonne
  async create(data: { workflow: number; name: string; position: number }): Promise<TaskColumnDto> {
    const response = await api.post('/columns/', data);
    return response.data;
  },

  // Mettre à jour une colonne (Renommer)
  async update(id: number, data: { name: string }): Promise<TaskColumnDto> {
    const response = await api.patch(`/columns/${id}/`, data);
    return response.data;
  },

  // Supprimer une colonne
  async delete(id: number): Promise<void> {
    await api.delete(`/columns/${id}/`);
  },
};

// =========================
// TASK
// =========================
export const taskService = {
  async getAll(filters?: {
  workflow?: number;
  column?: number;
  all?: boolean;
}) {
  const { all, workflow, column } = filters ?? {};

  const params: any = {
    ordering: 'position',
  };

  if (!all) {
    if (workflow !== undefined) params.workflow = workflow;
    if (column !== undefined) params.column = column;
  }

  const response = await api.get('/tasks/', { params });
  return response.data.results ?? response.data;
},

  async getById(id: number): Promise<TaskDto> {
    const response = await api.get(`/tasks/${id}/`);
    return response.data;
  },

  async create(data: TaskCreateDto): Promise<TaskDto> {
     console.log(" ENVOI TASK CREATE:", data);
    const response = await api.post('/tasks/', data);
    console.log(" RÉPONSE BACKEND:", response.data); 
    return response.data;
  },

  async update(id: number, data: TaskUpdateDto): Promise<TaskDto> {
    const response = await api.patch(`/tasks/${id}/`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/tasks/${id}/`);
  },

  async move(taskId: number, columnId: number, position?: number): Promise<TaskDto> {
    const response = await api.patch(`/tasks/${taskId}/`, {
      column: columnId,
      ...(position !== undefined ? { position } : {}),
    });
    return response.data;
  },
};